export let getTime = function(str) {
  let time = 0
  str = str.replace(',', '.')
  let data = str.split(':')
  time += parseInt(data[0]) * 60 * 60
  time += parseInt(data[1]) * 60
  time += parseFloat(data[2])
  return time
}

export let convert = function(lines) {
  for (let line of lines) {
    line.startTime = getTime(line.startTime)
    line.endTime = getTime(line.endTime)
  }
  return lines
}

